module.exports = __webpack_public_path__ + "img/logo-mobile.17931e37.svg";